const additionalFeaturesModal = {
    namespaced: true,
    state: () => ({
        product: null,
        isOpen: false
    }),
    mutations: {
        SET_PRODUCT(state, product) {
            state.product = product;
        },
        SET_IS_OPEN(state, isOpen) {
            state.isOpen = isOpen;
        },
        OPEN_MODAL(state, { product, selectedSize }) {
            state.product = { ...product, selectedSize };
            state.isOpen = true;
        },
        CLOSE_MODAL(state) {
            state.product = null;
            state.isOpen = false;
        }
    },
    actions: {
        setProduct({ commit }, product) {
            commit('SET_PRODUCT', product);
        },
        setIsOpen({ commit }, isOpen) {
            commit('SET_IS_OPEN', isOpen);
        },
        openModal({ commit }, { product, selectedSize }) {
            commit('OPEN_MODAL', { product, selectedSize });
        },
        closeModal({ commit }) {
            commit('CLOSE_MODAL');
        }
    },
    getters: {
        product: (state) => state.product,
        isOpen: (state) => state.isOpen
    }
};
export default additionalFeaturesModal;
